import { Container, Row, Col } from 'react-bootstrap';
import { PaSearchFilterProps } from '../types';
import useAccountContext from '../../../authentication/hooks';
import PaFilterMenu from './paFilterMenu';

const PaSearchFilter = (props: PaSearchFilterProps) => {
    const {
        containerClassName = '', // default props
        className = '', // default props
        initialFilters,
        setInitialFilters,
        setCurrentPage,
        placeholder = '',
    } = props;
    const accountContext = useAccountContext();
    const accountDetails = accountContext?.details;

    const handleSearchSubmit = (searchValue: string | undefined) => {
        setCurrentPage(1); // Reset to the first page on search
        setInitialFilters((prevFilters) => ({
            ...prevFilters,
            filterSearchText: searchValue,
            filterCurrentPage: 1,
        }));

        const profile = {
            filterYearType: initialFilters?.filterYearType,
            filterStatusType: initialFilters?.filterStatusType,
            filtersChanged: initialFilters?.filtersChanged,
            filterCurrentPage: 1,
            filterActiveTab: initialFilters?.filterActiveTab,
            filterSearchText: searchValue,
        };
        const userProfile = {
            ...accountDetails?.userProfile,
            patternApprovalDashboard: profile,
        };
        accountContext?.setUserProfile(userProfile);
    };

    return (
        <Container className={containerClassName}>
            <Row className={className}>
                <Col className='d-flex justify-content-end'>
                    {/*  <SearchBox
                        containerClassName='d-block me-3 mb-0 col col-lg-7'
                        onSearchSubmit={handleSearchSubmit}
                        initialSearchValue={initialFilters?.filterSearchText}
                        placeholder={placeholder}
                    /> */}
                    <PaFilterMenu
                        setCurrentPage={setCurrentPage}
                        initialFilters={initialFilters}
                        setInitialFilters={setInitialFilters}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default PaSearchFilter;
